import React from "react";
import { useTranslation } from 'react-i18next';
import cn from "classnames";
import { getDaysBetweenDates } from '@utils/progress';
import TimeIcon from '@assets/icons/outline/clock-3.svg?react';
import styles from "./ToDisposal.module.scss";

export interface ToDisposalProps {
  disposalDate?: string;
  status: string;
}

const ToDisposal = ({ disposalDate, status }: ToDisposalProps): React.ReactNode => {
  const { t } = useTranslation();

  if (!disposalDate || status !== "Assembled") return null;
  const days = getDaysBetweenDates(null, disposalDate);
  if (days < 0) return null;

  return (
    <div className={cn(styles.toUtilization, days <= 3 && styles.toUtilizationRed)}>
      <TimeIcon />
      {days}
      {t("fbpPage.ordersTab.days")}
    </div>
  );
};

export default ToDisposal;
